import Header from "../components/header";
import SubpageHero from "../components/subpage-hero";
import RoadmapList from "../components/roadmap-list";
import PricingHolder from "../components/pricing-holder";

const HEADER_IMG = "https://images.pexels.com/photos/39811/pexels-photo-39811.jpeg";

function RoadmapPage() {
  const navigateToSignup = () => {
    window.location.href = "/signup";
  };

  const navigateToLogin = () => {
    window.location.href = "/login";
  };

  return (
    <>
      <Header
        hideIcons={true}
        CTA="Sign up"
        functionForButton={navigateToSignup}
        CTA2="Log in"
        functionForButton2={navigateToLogin}
        displayAdditionalNavComponents={true}
      />

      <main className="homepage">
        <SubpageHero
          headline="Roadmap"
          tag="What we're building next"
          desc="Our planned features, in chronological order. We're focused on helping you read your market clearly and respond while it still matters."
          img={HEADER_IMG}
        />

        <RoadmapList />

        <section className="pricing-section">
          <PricingHolder />
        </section>
      </main>
    </>
  );
}

export default RoadmapPage;
